import { DateTime } from 'luxon';
import { IModel, Model, ModelRecord } from './Model';
import {
  IVisitSectionTypeModel,
  VisitSectionTypeModel,
} from './VisitSectionTypeModel';

export interface IVisitSectionVersionModel extends IModel {
  visitSectionVersionId: number;
  visitSectionTypeId: number;
  visitSectionType: IVisitSectionTypeModel;
  visitId: number;
  dateCreated: string;
  dateUpdated: string;
  userUpdatedTitle: string;
  userUpdatedFirstName: string;
  userUpdatedLastName: string;
}

export class VisitSectionVersionModel
  extends Model
  implements ModelRecord<IVisitSectionVersionModel>
{
  visitSectionVersionId: number;
  visitSectionTypeId: number;
  visitSectionType: VisitSectionTypeModel;
  visitId: number;
  dateCreated: DateTime;
  dateUpdated: DateTime;
  userUpdatedTitle: string;
  userUpdatedFirstName: string;
  userUpdatedLastName: string;

  constructor(params: Partial<IVisitSectionVersionModel>) {
    super(params);
    this.visitSectionVersionId = _.defaultTo(params.visitSectionVersionId, 0);
    this.visitSectionTypeId = _.defaultTo(params.visitSectionTypeId, 0);
    this.visitSectionType = new VisitSectionTypeModel(
      params.visitSectionType ?? {},
    );
    this.visitId = _.defaultTo(params.visitId, 0);
    this.dateCreated = params.dateCreated
      ? DateTime.fromISO(params.dateCreated, { zone: 'utc' })
      : DateTime.min();
    this.dateUpdated = params.dateUpdated
      ? DateTime.fromISO(params.dateUpdated, { zone: 'utc' })
      : DateTime.min();
    this.userUpdatedTitle = _.defaultTo(params.userUpdatedTitle, '');
    this.userUpdatedFirstName = _.defaultTo(params.userUpdatedFirstName, '');
    this.userUpdatedLastName = _.defaultTo(params.userUpdatedLastName, '');
  }
}
